import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { uptcp } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import UPTCPContent from '../../../components/Dashboard/Workspace/UPTCPContent'


const UPTCP = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.uptcp' })}
           pathname={window.location.origin + NamedRoutes.workspace.uptcp}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={uptcp.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.uptcp' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<UPTCPContent/>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default UPTCP

